import React, { ReactNode } from 'react';
import { HelpBlogLayoutContainer } from '@dealstack/frontend/app/pages/HelpBlog/HelpBlogLayout/HelpBlogLayout.styles.tsx';

interface Props {
	children: ReactNode;
	title?: string;
	bannerImageUrl?: string;
}

export const HelpBlogLayout = ({ title, children, bannerImageUrl }: Props) => {
	return (
		<HelpBlogLayoutContainer>
			<div className="image">
				{bannerImageUrl && <img src={bannerImageUrl} alt={title} />}
			</div>

			<div className="page-content">{children}</div>
		</HelpBlogLayoutContainer>
	);
};
